module.exports = __webpack_public_path__ + "img/folios--icon.726f0557.svg";